module.exports = __webpack_public_path__ + "static/img/bg-career-welfare.34a1dae5.jpg";